<div class="row">
    <div class="col-xl-6 col-md-6">
      <div class="card">
        <!--GESTION AGENTE-->
        <div class="card-header">
          <h3>{{ "foro.crearpost" | translate }}</h3>
        </div>
        <div class="card-body">
          <div class="form-group">
            <!--Lista idiomas-->
  
            <kendo-label text="{{ 'publicaciones.idiomas' | translate }}">
            </kendo-label>
  
            <div class="caja">
              <kendo-dropdownlist
                #dropdownI
                [data]="listaIdiomas"
                textField="nombre"
                valueField="codigo"
                [(ngModel)]="selectedIdioma"
              ></kendo-dropdownlist>
            </div>
          </div>
  
          <div class="form-group">
            <label>{{ "recintos.lbl_nombre_recinto" | translate }}</label>
            <div class="caja">
              <!--Titulo-->
              <kendo-textbox
                placeholder="{{ 'recintos.ph_nombre' | translate }}"
                [clearButton]="true"
                [(ngModel)]="title"
              >
                <ng-template kendoTextBoxPrefixTemplate> </ng-template>
              </kendo-textbox>
            </div>
          </div>
  
          <!--Cuerpo-->
          <div class="form-group">
            <kendo-label
              text="{{ 'foro.mensaje' | translate }}"
            >
            {{message}}
            <kendo-editor [(ngModel)]="message" [pasteCleanupSettings]="pasteCleanupSettings"></kendo-editor>
            </kendo-label>
          </div>
  

          <!-- Traducciones -->
          <div class="form-group">
            <button
              type="button"
              class="btn btn-primary btn-sm mr-1"
              (click)="btnAddTraduccion()"
            >
              {{ "publicaciones.anadir" | translate }}
            </button>
            <div class="listado-traducciones">
              <div class="traduccion" *ngFor="let idioma of listaTraducciones">
                {{ idioma.nombre }}
  
                <button
                  type="button"
                  class="btn btn-info btn-sm mr-1"
                  (click)="btnDeleteTraduccion(idioma)"
                >
                  X
                </button>
              </div>
            </div>
            <!--Boton Publicar-->
            <button
              type="button"
              class="btn btn-success btn-sm mr-1"
              (click)="btnCrearPost()"
            >
              {{ "foro.crearpost" | translate }}
            </button>
            <button
              type="button"
              class="btn btn-danger btn-sm mr-1"
              (click)="btnCancelar()"
            >
              {{ "botones.cancelar" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  